import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteOtherWorkType from 'hooks/otherWorkType/useDeleteOtherWorkType';
import notificationHandler from 'utils/notifications';

interface IModalDeleteOtherWorkType {
  opened: boolean;
  handleClose: () => void;
  otherWorkTypeId?: string;
}

const ModalDeleteOtherWorkType = ({
  opened,
  otherWorkTypeId,
  handleClose,
}: IModalDeleteOtherWorkType): JSX.Element => {
  const deleteMutation = useDeleteOtherWorkType();

  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    if (otherWorkTypeId) {
      deleteMutation.mutate(otherWorkTypeId, {
        onSuccess: () => {
          successNotification('Other work type delete success', `Work type successfully deleted.`);
          handleClose();
        },
        onError: error => {
          errorNotification('Other work type delete failed', error.response?.data.message);
        },
      });
    }
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Other Work Type</Title>}
      size='auto'
    >
      <Stack>
        <Text>Are you sure you want to delete this other work type?</Text>
        <Text color='dimmed'>
          This action cannot be undone. It will delete this work type for all other coaches.
        </Text>
        <Group position='right'>
          <Button
            onClick={handleDelete}
            color='red'
            loading={deleteMutation.isLoading}
            data-cy='submitDeleteOtherWorkTypeButton'
          >
            Submit
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalDeleteOtherWorkType;
